import {Badge, Box, Paper, Stack, Text} from '@mantine/core';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import runModal from 'ui-library/runModal';

import {ScientificModelInputFormModal} from './input-forms/InputForm';

interface ScientificModelCardProps {
  displayName: string;
  iconPath: string;
  category: string;
  systemName: string;
}

export function ScientificModelCard(props: ScientificModelCardProps): JSX.Element {
  const {displayName, iconPath, category, systemName} = props;

  const handleCardClick = (): void => {
    runModal(ScientificModelInputFormModal, {
      model: systemName,
    });
  };

  return (
    <Paper
      component="div"
      className={css(styles.card)}
      withBorder={true}
      radius="md"
      shadow="xs"
      p="lg"
      onClick={handleCardClick}
    >
      <Stack align="center" spacing="md">
        <Box className={css(styles.iconContainer)}>
          <img src={iconPath} alt={displayName} className={css(styles.icon)} />
        </Box>
        <Stack align="center" spacing="xs" style={{width: '100%'}}>
          <Text weight={600} align="center" size="md" style={{lineHeight: 1.3}}>
            {displayName}
          </Text>
          <Badge size="md" variant="light" radius="sm">
            {category}
          </Badge>
        </Stack>
      </Stack>
    </Paper>
  );
}

const styles = StyleSheet.create({
  card: {
    textAlign: 'center',
    userSelect: 'none',
    transition: 'box-shadow 0.15s ease-in-out, transform 0.15s ease-in-out',
    cursor: 'pointer',
    ':hover': {
      boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.1)',
      transform: 'translateY(-2px)',
    },
  },
  iconContainer: {
    width: 48,
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
});
